module.exports = __webpack_public_path__ + "static/img/12.9a4de03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/12.png
// module id = V+i0
// module chunks = 0